<template>
  <app-layout>
    <notifications-table></notifications-table>
  </app-layout>
</template>

<style lang="scss"></style>

<script>
import AppLayout from "../../layouts/AppLayout.vue";
import NotificationsTable from "./NotificationsTable/NotificationsTable.vue";
export default {
  components: {
    AppLayout,
    NotificationsTable
  },
  computed: {}
};
</script>
